<div class="st-delete-topic-stories">
    <div class="st-delete-topic-stories-body">
        <mat-icon
            big
            class="st-delete-topic-stories-body__delete-icon material-symbols-outlined"
            >delete</mat-icon
        >
        <span class="st-delete-topic-stories-body__slug">{{ languageSettings().PSTWebDeleteTopicStoriesSlug }}</span>
        <div class="st-delete-topic-stories-body__text">
            {{ text() }}
        </div>
        <div class="st-delete-topic-stories-body__options">
            <mat-radio-group
                aria-label="Select an option"
                (change)="deletionMode.set($event.value)">
                <mat-radio-button
                    checked
                    [value]="TopicDeletionMode.SAVE_STORIES"
                    >{{ languageSettings().PSTWebDeleteTopicStoriesSaveStories }}</mat-radio-button
                >
                <mat-radio-button [value]="TopicDeletionMode.DELETE_ALL">{{ languageSettings().PSTWebDeleteTopicStoriesDeleteAll }}</mat-radio-button>
            </mat-radio-group>
        </div>
    </div>
    <div class="st-delete-topic-stories-footer">
        <button
            mat-button
            (click)="cancel()">
            {{ languageSettings().PSTWebCancelButtonLabel }}
        </button>
        <button
            mat-flat-button
            class="st-delete-topic-stories-footer__delete-btn"
            (click)="deletion()">
            {{ languageSettings().PSTWebDeleteViewState }}
        </button>
    </div>
</div>
